import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text-center"
  }, [_c(VDialog, {
    attrs: {
      persistent: "",
      "max-width": "700"
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, [_c(VCard, [_c(VCardTitle, {
    staticClass: "dialog-title"
  }, [_vm._v("Verify your bank account")]), _c(VCardText, {
    staticClass: "my-3"
  }, [_c("p", [_vm._v("We need to verify your bank account details.")]), _c("div", {
    staticClass: "ol-title"
  }, [_vm._v("How to verify?")]), _c("ol", [_c("li", [_vm._v(" We will make "), _c("strong", [_vm._v("one or two small deposits (smaller than 1.00$)")]), _vm._v(" on your checking account. An email from our partner "), _c("strong", [_vm._v("Stripe")]), _vm._v(" will be sent to you when the deposits are expected to arrive. "), _c("div", {
    staticClass: "tip mt-2"
  }, [_c("i", {
    staticClass: "fas fa-lightbulb pr-2"
  }), _vm._v(" Please note, it can take up to 2 business days to complete this transfer. ")])]), _c("li", [_vm._v("Go to your checking account and find the deposit.")]), _c("li", [_vm._v(" Open the link below and follow the instructions. "), _c("strong", [_vm._v("We strongly recommand you to back up the link.")]), _c("div", {
    staticClass: "link"
  }, [_c(VTextField, {
    attrs: {
      readonly: "",
      value: _vm.linkUrl
    }
  }), _c(VTooltip, {
    attrs: {
      top: "",
      "open-on-hover": false,
      "open-on-focus": false,
      "close-delay": "1400"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VBtn, _vm._g(_vm._b({
          attrs: {
            rounded: ""
          },
          on: {
            click: _vm.copyLink
          }
        }, "v-btn", attrs, false), on), [_vm._v("Copy")])];
      }
    }])
  }, [_c("span", [_vm._v("Copied!")])])], 1)])]), _c("div", {
    staticClass: "text-center mt-7"
  }, [_c(VCheckbox, {
    model: {
      value: _vm.canContinue,
      callback: function callback($$v) {
        _vm.canContinue = $$v;
      },
      expression: "canContinue"
    }
  }, [_c("div", {
    staticClass: "label-mandatory",
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(" I understand that these actions are necessary for my order to be validated. ")])]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      disabled: !_vm.canContinue,
      rounded: true
    },
    on: {
      click: _vm.continueToSave
    }
  }, [_vm._v(" Continue ")])], 1)])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };